import { IEmulator } from '../src/api/emulator';

const BUFFER_SIZE = 2048;

export class Audio {
  public emulator: IEmulator;

  private ctx = new AudioContext({
    sampleRate: 44100,
  });
  private source = this.ctx.createBufferSource();
  private scriptNode = this.ctx.createScriptProcessor(BUFFER_SIZE, 0, 1);
  private buffer: number[] = [];

  public start(): void {
    this.scriptNode.onaudioprocess = e => this.process(e);

    this.source.connect(this.scriptNode);
    this.scriptNode.connect(this.ctx.destination);
    if (this.source.start) {
      this.source.start();
    }
  }

  public get sampleRate(): number {
    return this.ctx.sampleRate;
  }

  public async resume(): Promise<void> {
    if (this.ctx.state === 'suspended') {
      await this.ctx.resume();
    }
  }

  public async suspend(): Promise<void> {
    if (this.ctx.state === 'running') {
      await this.ctx.suspend();
    }
  }

  public onSample(volume: number): void {
    this.buffer.push(volume);
  }

  private process(e: AudioProcessingEvent) {
    const outputData = e.outputBuffer.getChannelData(0);

    if (this.buffer.length >= outputData.length) {
      for (let sample = 0; sample < outputData.length; sample++) {
        const value = this.buffer.shift();
        outputData[sample] = value === undefined ? 0 : value;
      }
    } else if (this.buffer.length > 0) {
      for (let sample = 0; sample < outputData.length; sample++) {
        const index = Math.floor(sample * this.buffer.length / outputData.length);
        outputData[sample] = this.buffer[index] ?? 0;
      }

      this.buffer = [];
    } else {
      for (let sample = 0; sample < outputData.length; sample++) {
        outputData[sample] = 0;
      }
    }
  }
}
